import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import {
  AddIngredientRequestPayload,
  IngredientDailyUsage,
  IngredientStock,
} from '../../../store/entities/ingredients/ingredients.types';
import { APIManagerConfig } from '../apiManager';

const IngredientServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getIngredientList: (includeDeleted = false): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/ingredients`, {
        params: {
          includeDeleted,
        },
      }).then((res) => res.data),
    getIngredient: (id): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/ingredients/${id}`).then((res) => res.data),
    addIngredient: (data, payload: AddIngredientRequestPayload): Promise<any> =>
      HTTPBase.post(`farm/${config.farmId}/ingredients`, data, { headers: { formName: payload.formName } }).then(
        (res) => res.data,
      ),
    editIngredient: (ingredientId, data, formName: FormName): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/ingredients/${ingredientId}`, data, {
        headers: { formName },
      }).then((res) => res.data),
    deleteIngredient: (ingredientId, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/ingredients/${ingredientId}`, { headers: { formName } }).then(
        (res) => res.data,
      ),
    getIngredientChangelogDrymatter: (id): Promise<any> =>
      HTTPBase.get(`ingredients/${id}/changelog/drymatter`).then((res) => res.data),
    getIngredientChangelogPrice: (id): Promise<any> =>
      HTTPBase.get(`ingredients/${id}/changelog/price`).then((res) => res.data),
    getIngredientDrymatters: (id): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/ingredients/${id}/drymatters`).then((res) => res.data),
    getIngredientStocks: (id): Promise<IngredientStock[]> =>
      HTTPBase.get(`farm/${config.farmId}/ingredients/${id}/stocks`).then((res) => res.data),
    getIngredientStock: (ingredientId: number, stockId: number): Promise<IngredientStock> =>
      HTTPBase.get(`farm/${config.farmId}/ingredients/${ingredientId}/stocks/${stockId}`).then((res) => res.data),
    addIngredientStock: (
      ingredientId: string,
      stock: Partial<IngredientStock>,
      formName: FormName,
    ): Promise<IngredientStock> =>
      HTTPBase.post(`farm/${config.farmId}/ingredients/${ingredientId}/stocks`, stock, { headers: { formName } }).then(
        (res) => res.data,
      ),
    editIngredientStock: (ingredientId: number, stock: IngredientStock, formName: FormName): Promise<IngredientStock> =>
      HTTPBase.patch(`farm/${config.farmId}/ingredients/${ingredientId}/stocks`, stock, { headers: { formName } }).then(
        (res) => res.data,
      ),
    getIngredientDailyUsage: (id: string): Promise<IngredientDailyUsage> =>
      HTTPBase.get(`farm/${config.farmId}/ingredients/${id}/dailyusage`).then((res) => res.data),
  };
};

export default IngredientServiceFactory;
